// Is this the correct default? Shouldn't it be null?

interface IWorksheet {
  worksheets?: any;
}

let defaultWorksheets: IWorksheet = {};

import { map } from 'lodash-es';

export const UPDATE_WORKSHEETS = 'WORKSHEETS::UPDATE_WORKSHEETS';
export const UPDATE_SELECTED_WORKSHEET =
  'WORKSHEETS::UPDATE_SELECTED_WORKSHEET';
export const LOAD_HEADERS = 'WORKSHEETS::LOAD_HEADERS';
export const HEADERS_LOADED = 'WORKSHEETS::HEADERS_LOADED';
export const HEADERS_LOAD_ERROR = 'WORKSHEETS::HEADERS_LOAD_ERROR';
export const UPDATE_ROW_INDEX = 'WORKSHEETS::UPDATE_ROW_INDEX';
export const UPDATE_COLUMN_MAPPINGS = 'WORKSHEETS::UPDATE_COLUMN_MAPPINGS';

interface IAction {
  type: string;
  data: any;
}

export function worksheetsReducer(state = defaultWorksheets, action: IAction) {
  let { type, data } = action;

  let worksheets;

  switch (type) {
    case 'SELECT_FILE':
      return defaultWorksheets;

    case UPDATE_WORKSHEETS:
      let worksheetNames = map(data, 'name');

      return Object.assign({}, state, {
        worksheets: data,
        names: worksheetNames,
        selectedWorksheetName:
          worksheetNames.length > 0 ? worksheetNames[0] : null
      });

    case UPDATE_SELECTED_WORKSHEET:
      return Object.assign({}, state, {
        selectedWorksheetName: data
      });

    case LOAD_HEADERS:
      worksheets = state.worksheets.map((worksheet) => {
        if (worksheet === data.worksheet) {
          return Object.assign({}, worksheet, {
            headers: {
              isLoaded: false,
              isLoading: true
            }
          });
        } else {
          return worksheet;
        }
      });

      return Object.assign({}, state, {
        worksheets
      });

    case HEADERS_LOADED:
      worksheets = state.worksheets.map((worksheet) => {
        if (worksheet === data.worksheet) {
          return Object.assign({}, worksheet, {
            headers: {
              isLoaded: true,
              isLoading: false,
              rowIndex: data.rowIndex,
              rows: data.rows
            }
          });
        } else {
          return worksheet;
        }
      });

      return Object.assign({}, state, {
        worksheets
      });

    case HEADERS_LOAD_ERROR:
      worksheets = state.worksheets.map((worksheet) => {
        if (worksheet === data.worksheet) {
          return Object.assign({}, worksheet, {
            headers: {
              isLoaded: false,
              isLoading: false,
              error: data.error
            }
          });
        } else {
          return worksheet;
        }
      });

      return Object.assign({}, state, {
        worksheets
      });

    case UPDATE_ROW_INDEX:
      worksheets = state.worksheets.map((worksheet) => {
        if (worksheet === data.worksheet) {
          let headers = Object.assign({}, worksheet.headers, {
            rowIndex: data.rowIndex
          });

          return Object.assign({}, worksheet, {
            headers
          });
        }

        return worksheet;
      });

      return Object.assign({}, state, {
        worksheets
      });

    case UPDATE_COLUMN_MAPPINGS:
      worksheets = state.worksheets.map((worksheet) => {
        if (worksheet === data.worksheet) {
          let newWorksheet = Object.assign({}, worksheet, {
            columnMappings: [].concat(data.columnMappings)
          });
          return newWorksheet;
        } else {
          return worksheet;
        }
      });

      return Object.assign({}, state, {
        worksheets
      });

    default:
      return state;
  }
}
